<template>
  <footer class="bg-slate-900 text-gray-200">
    <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
      <div class="sm:flex sm:items-center sm:justify-between">
        <a href="https://entegy.events/" class="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse">
          <img :src="logo" class="h-10" alt="Entegy Logo" />
          
        </a>
        <ul class="flex flex-col gap-2 md:gap-0 md:flex-row flex-wrap md:items-center mb-6 text-sm font-medium text-body sm:mb-0">
          <li>
            <router-link to="/about" class="hover:underline me-4 md:me-6">About</router-link>
          </li>
          <li>
            <router-link to="/privacy-policy" class="hover:underline me-4 md:me-6">Privacy Policy</router-link>
          </li>
          <li>
            <router-link to="/supply-terms" class="hover:underline me-4 md:me-6">Supply Terms</router-link>
          </li>
          <li>
            <a href="https://security.entegy.events/" class="hover:underline me-4 md:me-6">Trust Center</a>
          </li>
          <li>
            <router-link to="/contact" class="hover:underline">Contact</router-link>
          </li>
        </ul>
      </div>
      
      <div class="mt-8 block text-sm text-body sm:text-center">© 2026 <a href="https://entegy.events/" class="hover:underline">Entegy</a>. All Rights Reserved.</div>
    </div>
    </footer>


</template>

<script setup>
import logo from '@/images/entegy-logo-white.svg'
// Footer component
</script>
